/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketScheduleResponse } from '../../models/ticket-schedule-response';

export interface ScheduleControllerFindAllSchedules$Params {
  related_ticket_id?: number;
  related_registry_id?: number;
  schedule_status_id?: number;
  assigned_user_id?: number;
}

export function scheduleControllerFindAllSchedules(http: HttpClient, rootUrl: string, params?: ScheduleControllerFindAllSchedules$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketScheduleResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, scheduleControllerFindAllSchedules.PATH, 'get');
  if (params) {
    rb.query('related_ticket_id', params.related_ticket_id, {});
    rb.query('related_registry_id', params.related_registry_id, {});
    rb.query('schedule_status_id', params.schedule_status_id, {});
    rb.query('assigned_user_id', params.assigned_user_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketScheduleResponse;
      }>;
    })
  );
}

scheduleControllerFindAllSchedules.PATH = '/schedule';
